export default "__VITE_ASSET__Bom_Tsud__"